export function Date_toYMD(myDate) {
    if (myDate == null) {
        return "";
    }
    if (!myDate.getFullYear) {
        return myDate
    }
    let year, month, day;
    year = String(myDate.getFullYear());
    month = String(myDate.getMonth() + 1);
    if (month.length == 1) {
        month = "0" + month;
    }
    day = String(myDate.getDate());
    if (day.length == 1) {
        day = "0" + day;
    }
    return year + "-" + month + "-" + day;
}

export function Date_toMysqlTime(myDateTime) {
    if (myDateTime == null) {
        return "";
    }
    if (!myDateTime.getHours()) {
        return myDateTime
    }
    let h, m, s;
    h = String(myDateTime.getHours());
    m = String(myDateTime.getMinutes());
    s = String(myDateTime.getSeconds());
    if (h.length == 1) {
        h = "0" + h;
    }
    if (m.length == 1) {
        m = "0" + m;
    }
    if (s.length == 1) {
        s = "0" + s;
    }
    return h + ":" + m + ":" + s;
}
